import React, { Component } from "react";
import _ from "lodash";
import {formatMoney} from "accounting-js";

class ActivityWidget extends Component{
	render() {
		let { disabled, goal, goals } = this.props;
		let goalActivities = _.find(goals.list, {id: goal.proigualdad_goal_id});
		return (
			<div>
				<label htmlFor="activityAdd" className="label">Seleccionar actividades</label>
				<div className="field has-addons">
					<div className="control is-expanded">
						<div className="select is-fullwidth">
							<select ref="activitySelect" disabled={disabled} id="activityAdd" onChange={() => this._activityValue()}>
								<option value={0} defaultValue>--- Actividades ---</option>
								{!_.isEmpty(goalActivities) && !_.isEmpty(goalActivities.activities) ? _.map(goalActivities.activities, (item, j) => {
									return <option value={item.id} key={j}>{item.name}</option>
								}): ''}
							</select>
						</div>
					</div>
					<div className="control">
						<input type="number" ref="quantity" id="quantity" placeholder="Cantidad" className="input" min="0" step="1" defaultValue={1} onChange={() => this._activityValue()} disabled={disabled} />
					</div>
					<div className="control">
						<input type="text" ref="total" id="total" placeholder="$0.00" className="input" readOnly disabled={disabled} />
					</div>
					<div className="control">
						<button type="button" className="button is-primary" onClick={() => this._addActivity()} disabled={disabled}>Agregar</button>
					</div>
				</div>
			</div>
		)
	}

	_addActivity() {
		let { goal, goals } = this.props;
		//let selected = _.findKey(projects.goals, {proigualdad_goal_id: _.toInteger(goal.proigualdad_goal_id)});
		let goalKey = _.findKey(goals.list, {id: _.toInteger(goal.proigualdad_goal_id)});
		let activity = _.find(goals.list[goalKey].activities, {id: _.toInteger(this.refs.activitySelect.value)});
		let hasIt = _.find(goal.project_goal_activities, {proigualdad_activity_id: activity.id});
		let activitySize = _.size(goal.project_goal_activities);
		if(hasIt === undefined && activitySize <= 4){
			this.props.add(`projects.edit.project_goal_activities`, {
				proigualdad_activity_id: _.toInteger(this.refs.activitySelect.value),
				name: activity.name,
				quantity: _.toInteger(this.refs.quantity.value),
				amount: activity.amount,
				total: _.toInteger(this.refs.quantity.value) * activity.amount,
				mandatory: activity.mandatory,
				verification_media: activity.verification_media[0]
			});
			let newTotal = (_.toNumber(goal.total) + (_.toInteger(this.refs.quantity.value) * activity.amount));
			//this.props.setProjectGoalTotal(goalKey, newTotal);
			this.props.change(`projects.edit.total`, newTotal);
			this.refs.activitySelect.value = 0;
			this.refs.quantity.value = 1;
			this.refs.total.value = '';
		}else if(activitySize >= 5) {
			//alert('Cada meta puede tener un máximo de 5 actividades');
			this.props.setSystemNotification('¡Oh no!', 'Cada meta puede tener un máximo de 5 actividades', 'danger');
		}else{
			//alert('No se pueden duplicar actividades');
			this.props.setSystemNotification('¡Oh no!', 'No se pueden duplicar actividades', 'danger');

		}
	}

	_activityValue() {
		let { goal, goals } = this.props;
		let goalActivities = _.find(goals.list, {id: goal.proigualdad_goal_id});
		let activity = _.find(goalActivities.activities, {id:_.toInteger(this.refs.activitySelect.value)});
		if(activity) {
			this.refs.total.value = formatMoney(_.toNumber(this.refs.quantity.value * activity.amount));
		}else {
			this.refs.total.value = formatMoney(0);
		}
	}
}

export default ActivityWidget;


// WEBPACK FOOTER //
// ./src/elements/projects/widgets/activities.jsx